import { api } from "../api";

/**
 * loginUserByToken - Function that tries to login an user by JWT token  
 * /authenticator/token  
 * method GET 
 * @async-function
 */
const loginUserByToken = async (token: string) => {
  const response = await api.get(
    "/authenticator/token",
    {
      // params: { token },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }
  );
  return response;
};

export default loginUserByToken;


